import { render, staticRenderFns } from "./PaperDetail.vue?vue&type=template&id=597d06b7&scoped=true"
import script from "./PaperDetail.vue?vue&type=script&lang=js"
export * from "./PaperDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d06b7",
  null
  
)

export default component.exports